// extracted by mini-css-extract-plugin
var _1 = "CaoQYpjnJyW8y5nu2Poa";
var _2 = "DKKYzODkJ2nGxVgght0Q";
var _3 = "B7SSiwDu8qBPL7iCjgqO";
var _4 = "tfQzIDQkD0b9bnUz4Po5";
export { _1 as "employeeCard", _2 as "people", _3 as "title", _4 as "wrapper" }
